import React from 'react';
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { ServiceItemProps } from '../types';
import ServiceItemPresentation from './ServiceItemPresentation';
import { SectionAnchor } from '../../../shared/components';

/**
 * Props for the ServicesPresentationComponent
 */
export interface ServicesPresentationProps {
  /** ID for the section */
  id: string;
  
  /** Heading for the section */
  heading: string;
  
  /** Description for the section */
  description: string;
  
  /** Services to display */
  services: ServiceItemProps[];
}

/**
 * Presentation component for the Services section
 */
const ServicesPresentation: React.FC<ServicesPresentationProps> = ({
  id,
  heading,
  description,
  services
}) => {
  return (
    <>
      <SectionAnchor id={id} />
      <Box
        as="section"
        pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}
        bg="gray.50"
      >
      <Container maxW="container.xl">
        <VStack spacing={12} align="center">
          <Box textAlign="center" maxW="800px">
            <Heading 
              as="h2" 
              size="xl" 
              mb={4}
              bgGradient="linear(to-r, brand.primary.dark, brand.primary.base)"
              bgClip="text"
            >
              {heading}
            </Heading>
            <Text fontSize="lg" color="gray.600">
              {description}
            </Text>
          </Box>
          
          <SimpleGrid 
            columns={{ base: 1, md: 2, lg: 3 }} 
            spacing={8} 
            width="full"
          >
            {services.map((service, index) => (
              <ServiceItemPresentation 
                key={index}
                title={service.title}
                description={service.description}
                icon={service.icon}
              />
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
    </>
  );
};

export default ServicesPresentation;